import script from "./ContactAddClientDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactAddClientDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ContactAddClientDropdown.vue?vue&type=style&index=0&id=4c6740e9&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c6740e9"]])

export default __exports__